import { render, staticRenderFns } from "./notificationEdit.vue?vue&type=template&id=c0d5c2ec&scoped=true&lang=html"
import script from "./notificationEdit.vue?vue&type=script&lang=js"
export * from "./notificationEdit.vue?vue&type=script&lang=js"
import style0 from "./notificationEdit.vue?vue&type=style&index=0&id=c0d5c2ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d5c2ec",
  null
  
)

export default component.exports